import {
    AktivnostiProxy,
    B2BPodatakOsobe,
    B2BPodatakVozila, B2BProvajderiProxy, DashboardProxy, DnevnoAktivnoVreme,
    DokumentaProxy, EvidencijaAktivnostiVozaca,
    EvidencijaAktivnostiVozacaProxy,
    Faktura,
    FaktureProxy,
    FileParameter,
    Firma,
    FirmaProxy,
    GrupaVozila,
    GrupeDelovaVozila,
    GrupeDelovaVozilaProxy,
    GrupeVozilaProxy,
    InterniRadniNaloziProxy,
    Izdatnica,
    IzdatniceProxy, IzvestajiOdrzavanjaVozilaProxy, IzvestajiProxy,
    MarkaVozila,
    MarkeIModeliVozilaProxy,
    ModelVozila,
    NabavkaVozila, NaloziZaSluzbenaPutovanjaProxy,
    NormativPotrosnjeGoriva,
    NovaLozinka,
    OdsustvaProxy,
    Odsustvo,
    Oprema,
    OpremaProxy,
    OrganizacionaJedinica,
    OrganizacioneJediniceProxy,
    Osoba,
    OsobeProxy,
    PodesavanjeSistema,
    PodesavanjeSistemaProxy,
    PodgrupaVozila,
    PodsetniciProxy,
    PodsetnikOsobe,
    PodsetnikVozila,
    PolisaOsiguranja,
    PoslovniPartner,
    PoslovniPartneriProxy,
    Povratnica,
    PovratniceProxy,
    PrijavaKvara,
    PrijaveKvaraProxy,
    Prijemnica,
    PrijemniceProxy, PutniNalog, PutniNaloziProxy,
    RadniNalog,
    RazlogOdbijanjaPrijaveKvara,
    RezervniDeloviProxy,
    RezervniDeo,
    ServisnaOperacija,
    ServisneOperacijeProxy, SipanjeGorivaProxy,
    StatusiVozilaProxy,
    StatusVozila, SteteProxy, StetniDogadjaj,
    TipVozila, TransakcijeKorisnika, TransakcijeProxy,
    TrebovanjaProxy,
    Trebovanje,
    TrosakVozila,
    TroskoviVozilaProxy,
    VozilaProxy,
    Vozilo,
    VrstaOdrzavanja,
    VrsteOdrzavanjaProxy,
    ZaliheRezervnihDelovaProxy,
    ObracunStimulacijeVozacimaProxy,
    BrisanjePodatakaProxy, ObrisiPodatkeRequest, ThreePLProxy
} from "@/services/BackendProxies";
import axios from 'axios';

class DataProxyService {
    vozilaProxy = new VozilaProxy('', axios);
    grupeVozilaProxy = new GrupeVozilaProxy('', axios);
    statusiVozilaProxy = new StatusiVozilaProxy('', axios);
    firmaProxy = new FirmaProxy('', axios);
    opremaProxy = new OpremaProxy('', axios);
    markeIModeliVozilaProxy = new MarkeIModeliVozilaProxy('', axios);
    organizacionaSemaProxy = new OrganizacioneJediniceProxy('', axios);
    osobeProxy = new OsobeProxy('', axios);
    vrsteOdrzavanjaProxy = new VrsteOdrzavanjaProxy(null, axios);
    grupeDelovaVozilaProxy = new GrupeDelovaVozilaProxy(null, axios);
    servisneOperacijeProxy = new ServisneOperacijeProxy(null, axios);
    rezervniDeloviProxy = new RezervniDeloviProxy(null, axios);
    poslovniPartneriProxy = new PoslovniPartneriProxy(null, axios);
    troskoviVozilaProxy = new TroskoviVozilaProxy(null, axios);
    prijavaKvaraProxy = new PrijaveKvaraProxy(null, axios);
    interniRadniNaloziProxy = new InterniRadniNaloziProxy(null, axios);
    trebovanjaProxy = new TrebovanjaProxy(null, axios);
    dokumentaProxy = new DokumentaProxy(null, axios);
    izdatnicaProxy = new IzdatniceProxy(null, axios);
    faktureProxy = new FaktureProxy(null, axios);
    prijemniceProxy = new PrijemniceProxy(null, axios);
    zaliheProxy = new ZaliheRezervnihDelovaProxy(null, axios);
    povratniceProxy = new PovratniceProxy(null, axios);
    podesavanjeSistemaProxy = new PodesavanjeSistemaProxy(null, axios);
    podsetniciProxy = new PodsetniciProxy(null, axios);
    odsustvaProxy = new OdsustvaProxy(null, axios);
    evidencijaAktivnostiProxy = new EvidencijaAktivnostiVozacaProxy(null, axios);
    putniNaloziProxy = new PutniNaloziProxy(null, axios);
    izvestajiOdrzavanjaVozila = new IzvestajiOdrzavanjaVozilaProxy(null, axios);
    sipanjeGorivaProxy = new SipanjeGorivaProxy(null, axios);
    dashboardProxy = new DashboardProxy(null, axios);
    izvestajiProxy = new IzvestajiProxy(null, axios);
    transakcijeProxy = new TransakcijeProxy(null, axios);
    b2bProvajderiProxy = new B2BProvajderiProxy(null, axios);
    aktivnostiProxy = new AktivnostiProxy(null, axios);
    steteProxy = new SteteProxy(null, axios);
    naloziZaSluzbenaPutovanjaProxy = new NaloziZaSluzbenaPutovanjaProxy(null, axios);
    obracunStimulacijeVozacimaProxy = new ObracunStimulacijeVozacimaProxy(null, axios);
    brisanjePodatakaProxy = new BrisanjePodatakaProxy(null, axios);
    threePLProxy = new ThreePLProxy(null, axios);

    vratiVozila() {
        return this.vozilaProxy.vratiVozila();
    }

    vratiVozilo(id: number) {
        return this.vozilaProxy.vratiVozilo(id);
    }

    vratiTipoveVozila() {
        return this.vozilaProxy.vratiTipoveVozila();
    }

    vratiTipoveMotoraVozila() {
        return this.vozilaProxy.vratiTipoveMotoraVozila();
    }

    vratiNormativPotrosnjeGoriva(id) {
        return this.vozilaProxy.vratiNormativPotrosnjeGorivaVozila(id);
    }

    sacuvajNormativPotrosnjeGoriva(id: number, normativ: NormativPotrosnjeGoriva[]) {
        return this.vozilaProxy.sacuvajNormativPotrosnjeGoriva(id, normativ);
    }

    sacuvajTipVozila(tip: TipVozila) {
        return this.vozilaProxy.sacuvajTipVozila(tip);
    }

    obrisiTipVozila(id: number) {
        return this.vozilaProxy.obrisiTipVozila(id);
    }

    vratiGrupeVozila() {
        return this.grupeVozilaProxy.vratiGrupeVozila();
    }

    sacuvajGrupuVozila(grupaVozila: GrupaVozila) {
        return this.grupeVozilaProxy.sacuvajGrupuVozila(grupaVozila);
    }

    obrisiGrupuVozila(id) {
        return this.grupeVozilaProxy.obrisiGrupuVozila(id);
    }

    sacuvajPodgrupuVozila(podgrupaVozila: PodgrupaVozila) {
        return this.grupeVozilaProxy.sacuvajPodgrupuVozila(podgrupaVozila);
    }

    obrisiPodgrupuVozila(id) {
        return this.grupeVozilaProxy.obrisiPodgrupuVozila(id);
    }

    vratiStatuseVozila() {
        return this.statusiVozilaProxy.vratiStatuseVozila();
    }

    sacuvajStatusVozila(statusVozila: StatusVozila) {
        return this.statusiVozilaProxy.sacuvajStatusVozila(statusVozila);
    }

    obrisiStatusVozila(id: number) {
        return this.statusiVozilaProxy.obrisiStatusVozila(id);
    }

    vratiBojeVozila(term: string) {
        return this.vozilaProxy.vratiBojeVozila(term);
    }

    vratiNacineNabavkeVozila() {
        return this.vozilaProxy.vratiNacineNabavkeVozila();
    }

    vratiNabavkuVozila(id: number) {
        return this.vozilaProxy.vratiNabavkuVozila(id);
    }

    sacuvajNabavkuVozila(id: number, nabavka: NabavkaVozila) {
        return this.vozilaProxy.sacuvajNabavkuVozila(id, nabavka);
    }

    obrisiNabavkuVozila(id: number) {
        return this.vozilaProxy.obrisiNabavkuVozila(id);
    }

    sacuvajVozilo(vozilo: Vozilo) {
        return this.vozilaProxy.sacuvajVozilo(vozilo);
    }

    vratiPoliseVozila(id: number) {
        return this.vozilaProxy.vratiPoliseOsiguranja(id);
    }
    
    sacuvajPolise(vozilo: number, polise: PolisaOsiguranja[]) {
        return this.vozilaProxy.sacuvajPoliseOsiguranja(vozilo, polise);
    }

    vratiOsiguravajuceKuce(term: string) {
        return this.vozilaProxy.vratiOsiguravajuceKuce(term);
    }

    obrisiPolisu(vozilo: number, polisa: number) {
        return this.vozilaProxy.obrisiPolisuOsiguranja(vozilo, polisa);
    }

    vratiKategorijeVozila() {
        return this.vozilaProxy.vratiKategorijeVozila();
    }

    vratiFirmu() {
        return this.firmaProxy.vratiFirmu();
    }

    sacuvajFirmu(firma: Firma) {
        return this.firmaProxy.sacuvajFirmu(firma);
    }

    vratiOpremu() {
        return this.opremaProxy.vratiOpremu();
    }

    sacuvajOpremu(oprema: Oprema) {
        return this.opremaProxy.sacuvajOpremu(oprema);
    }

    obrisiOpremu(id: number) {
        return this.opremaProxy.obrisiOpremu(id);
    }

    vratiMarkeVozila() {
        return this.vozilaProxy.vratiMarkeVozila();
    }

    sacuvajMarkuVozila(markaVozila: MarkaVozila) {
        return this.markeIModeliVozilaProxy.sacuvajMarkuVozila(markaVozila);
    }

    obrisiMarkuVozila(id: number) {
        return this.markeIModeliVozilaProxy.obrisiMarkuVozila(id);
    }

    sacuvajModelVozila(modelVozila: ModelVozila) {
        return this.markeIModeliVozilaProxy.sacuvajModelVozila(modelVozila);
    }

    obrisiModelVozila(id: number) {
        return this.markeIModeliVozilaProxy.obrisiModelVozila(id);
    }

    vratiOrganizacioneJedinice() {
        return this.organizacionaSemaProxy.vratiOrganizacioneJedinice();
    }

    sacuvajOrganizacionuJedinicu(organizacionaJedinica: OrganizacionaJedinica) {
        return this.organizacionaSemaProxy.sacuvajOrganizacionuJedinicu(organizacionaJedinica);
    }

    obrisiOrganizacionuJedinicu(id: number) {
        return this.organizacionaSemaProxy.obrisiOrganizacionuJedinicu(id);
    }

    vratiSkladista() {
        return this.organizacionaSemaProxy.vratiSkladista();
    }

    vratiOsobe(samoAktivne: boolean) {
        return this.osobeProxy.vratiOsobe(samoAktivne);
    }

    sacuvajOsobu(osoba: Osoba) {
        return this.osobeProxy.sacuvajOsobu(osoba);
    }

    obrisiOsobu(idOsobe: number) {
        return this.osobeProxy.obrisiOsobu(idOsobe);
    }

    promeniLozinku(idOsobe: number, lozinka: string) {
        return this.osobeProxy.promeniLozinku(idOsobe, NovaLozinka.fromJS({lozinka}));
    }

    vratiOsobu(idOsobe: number) {
        return this.osobeProxy.vratiOsobu(idOsobe);
    }

    vratiFunkcijeOsoba() {
        return this.osobeProxy.vratiFunkcijeOsoba();
    }

    vratiVozace() {
        return this.osobeProxy.vratiVozace();
    }

    vratiServisere() {
        return this.osobeProxy.vratiServisere();
    }

    vratiMagacionere() {
        return this.osobeProxy.vratiMagacionere();
    }

    vratiB2BPodatkeVozila(id: number) {
        return this.vozilaProxy.vratiB2BPodatkeVozila(id);
    }

    sacuvajB2BPodatkeVozila(id: number, podaci: B2BPodatakVozila[]) {
        return this.vozilaProxy.sacuvajB2BPodatkeVozila(id, podaci);
    }

    vratiVrsteOdrzavanja() {
        return this.vrsteOdrzavanjaProxy.vratiVrsteOdrzavanja();
    }

    savucajVrstuOdrzavanja(vrstaOdrzavanja: VrstaOdrzavanja) {
        return this.vrsteOdrzavanjaProxy.sacuvajVrstuOdrzavanja(vrstaOdrzavanja);
    }

    obrisiVrstuOdrzavanja(id: number) {
        return this.vrsteOdrzavanjaProxy.obrisiVrstuOdrzavanja(id);
    }

    vratiGrupeDelovaVozila() {
        return this.grupeDelovaVozilaProxy.vratiGrupeDelovaVozila();
    }

    sacuvajGrupuDelovaVozila(grupaDelovaVozila: GrupeDelovaVozila) {
        return this.grupeDelovaVozilaProxy.sacuvajGrupuDelovaVozila(grupaDelovaVozila);
    }

    obrisiGrupuDelovaVozila(id: number) {
        return this.grupeDelovaVozilaProxy.obrisiGrupuDelovaVozila(id);
    }

    vratiServisneOperacije() {
        return this.servisneOperacijeProxy.vratiServisneOperacije();
    }

    sacuvajServisnuOperaciju(servisnaOperacija: ServisnaOperacija) {
        return this.servisneOperacijeProxy.sacuvajServisnuOperaciju(servisnaOperacija);
    }

    obrisiServisnuOperacaiju(id: number) {
        return this.servisneOperacijeProxy.obrisiServisnuOperaciju(id);
    }

    vratiRezervneDelove() {
        return this.rezervniDeloviProxy.vratiRezervneDelove();
    }

    sacuvajRezervniDeo(rezervniDeo: RezervniDeo) {
        return this.rezervniDeloviProxy.sacuvajRezervniDeo(rezervniDeo);
    }

    obrisiRezervniDeo(id: number) {
        return this.rezervniDeloviProxy.obrisiRezervniDeo(id);
    }

    vratiDelatnostiPoslovnihPartnera() {
        return this.poslovniPartneriProxy.vratiDelatnostiPoslovnihPartnera();
    }

    vratiPoslovnePartnere() {
        return this.poslovniPartneriProxy.vratiPoslovnePartnere();
    }

    vratiServise() {
        return this.poslovniPartneriProxy.vratiServise();
    }

    sacuvajPoslovnogPartnera(poslovniPartner: PoslovniPartner) {
        return this.poslovniPartneriProxy.sacuvajPoslovnogPartnera(poslovniPartner);
    }

    obrisiPoslovnogPartnera(id: number) {
        return this.poslovniPartneriProxy.obrisiPoslovnogPartnera(id);
    }

    vratiTroskoveVozila() {
        return this.troskoviVozilaProxy.vratiTroskoveVozila();
    }

    sacuvajTrosakVozila(trosakVozila: TrosakVozila) {
        return this.troskoviVozilaProxy.sacuvajTrosakVozila(trosakVozila);
    }

    obrisiTrosakVozila(id: number) {
        return this.troskoviVozilaProxy.obrisiTrosakVozila(id);
    }

    vratiPrijavuKvara(id: number) {
        return this.prijavaKvaraProxy.vratiPrijavuKvaraPoId(id);
    }

    vratiPrijaveKvara() {
        return this.prijavaKvaraProxy.vratiPrijaveKvara();
    }

    vratiPrijaveKvaraZaVozilo(voziloId?: number) {
        return this.prijavaKvaraProxy.vratiPrijaveKvaraZaVozilo(voziloId);
    }

    sacuvajPrijavuKvara(prijavaKvara: PrijavaKvara) {
        return this.prijavaKvaraProxy.sacuvajPrijavuKvara(prijavaKvara);
    }

    odobriPrijavuKvara(id: number) {
        return this.prijavaKvaraProxy.odobriPrijavuKvara(id);
    }

    odbiPrijavuKvara(idPrijaveKvara: number, razlog: RazlogOdbijanjaPrijaveKvara) {
        return this.prijavaKvaraProxy.odbiPrijavuKvara(idPrijaveKvara, razlog);
    }

    vratiVozilaKorisnika() {
        return this.vozilaProxy.vratiVozilaKorisnika();
    }

    vratiPripadajuceOsobe() {
        return this.osobeProxy.vratiPripadajuceOsobe();
    }

    sacuvajInterniRadniNalog(interniRadniNalog: RadniNalog) {
        return this.interniRadniNaloziProxy.sacuvajInterniRadniNalog(interniRadniNalog);
    }

    vratiInterneRadneNaloge() {
        return this.interniRadniNaloziProxy.vratiInterneRadneNaloge();
    }

    vratiInterniRadniNalogPoId(id: number) {
        return this.interniRadniNaloziProxy.vratiInterniRadniNalogPoId(id);
    }

    zakljuciInterniRadniNalog(radniNalog: RadniNalog) {
        return this.interniRadniNaloziProxy.zakljuciInterniRadniNalog(radniNalog);
    }

    sacuvajTrebovanje(trebovanje: Trebovanje) {
        return this.trebovanjaProxy.sacuvajTrebovanje(trebovanje);
    }

    vratiTrebovanja(idSkladista?: number) {
        return this.trebovanjaProxy.vratiTrebovanja(idSkladista);
    }

    vratiTrebovanjePoId(id: number) {
        return this.trebovanjaProxy.vratiTrebovanjePoId(id);
    }

    vratiDokumentaPoBroju(broj: string) {
        return this.dokumentaProxy.vratiDokumentaPoBroju(broj);
    }

    obrisiStavkuDokumenta(idStavke: number) {
        return this.dokumentaProxy.obrisiStavkuDokumenta(idStavke);
    }

    vratiIzdatnicuPoId(id: number) {
        return this.izdatnicaProxy.vratiIzdatnicuPoId(id);
    }

    sacuvajIzdatnicu(izdatnica: Izdatnica) {
        return this.izdatnicaProxy.sacuvajIzdatnicu(izdatnica);
    }

    zakljuciIzdatnicu(izdatnica: Izdatnica) {
        return this.izdatnicaProxy.zakljuciIzdatnicu(izdatnica);
    }

    vratiZatvoreneInterneRadneNaloge() {
        return this.interniRadniNaloziProxy.vratiZatvoreneInterneRadneNaloge();
    }

    vratiZatvorenInterniRadniNalogPoId(id: number) {
        return this.interniRadniNaloziProxy.vratiZatvorenInterniRadniNalogPoId(id);
    }

    potvrdiIntetniRadniNalog(radniNalog: RadniNalog) {
        return this.interniRadniNaloziProxy.potvrdiInterniRadniNalog(radniNalog);
    }
    vratiStavkeServisneOperacije(id: number) {
        return this.dokumentaProxy.vratiStavkeServisneOperacije(id);
    }

    vratiStavkeRezervnihDelova(id: number) {
        return this.dokumentaProxy.vratiStavkeRezervnihDelova(id);
    }

    vratiArtikalPoOpisu(deoNaziva: string) {
        return this.dokumentaProxy.vratiArtikalPoOpisu(deoNaziva);
    }

    sacuvajFakturu(faktura: Faktura ){
        return this.faktureProxy.sacuvajFakturu(faktura);
    }

    vratiFakturuPoId(id: number) {
        return this.faktureProxy.vratiFakturuPoId(id);
    }

    zakljuciFakturu(faktura: Faktura) {
        return this.faktureProxy.zakljuciFakturu(faktura);
    }

    vratiRezervneDelovePoKataloskomBroju(kataloskiBroj: string) {
        return this.rezervniDeloviProxy.vratiRezervneDelovePoKataloskomBroju(kataloskiBroj);
    }

    vratiRezervneDelovePoNazivu(naziv: string) {
        return this.rezervniDeloviProxy.vratiRezervneDelovePoNazivu(naziv);
    }

    vratiPrijemnicuPoId(id: number) {
        return this.prijemniceProxy.vratiPrijemnicuPoId(id);
    }

    sacuvajPrijemnicu(prijemnica: Prijemnica) {
        return this.prijemniceProxy.sacuvajPrijemnicu(prijemnica);
    }

    zakljuciPrijemnicu(prijemnica: Prijemnica) {
        return this.prijemniceProxy.zakljuciPrijemnicu(prijemnica);
    }

    vratiZaliheRezervnihDelova(skladiste: number) {
        return this.zaliheProxy.vratiZaliheUSkladistu(skladiste);
    }

    vratiPovratnicuPoId(id: number) {
        return this.povratniceProxy.vratiPovratnicuPoId(id);
    }

    sacuvajPovratnicu(povratnica: Povratnica) {
        return this.povratniceProxy.sacuvajPovratnicu(povratnica);
    }

    zakljuciPovratnicu(povratnica: Povratnica) {
        return this.povratniceProxy.zakljuciPovratnicu(povratnica);
    }
    
    pretraziDokumenteOdrzavanja(tip: string | null | undefined, 
                                godina: number | null | undefined, 
                                vozilo: number | null | undefined, 
                                dobavljac: number | null | undefined, 
                                odDatuma: Date | null | undefined, 
                                doDatuma: Date | null | undefined, 
                                status: number | null | undefined) {
        return this.dokumentaProxy.pretraziDokumente(tip, godina, vozilo, dobavljac, odDatuma, doDatuma, status);
    }

    vratiPregledDokumenta(tipDokumenta: string, id: number) {
        return this.dokumentaProxy.vratiPregledDokumenta(tipDokumenta, id);
    }
    vratiPovezanaDokumenta(id: number) {
        return this.dokumentaProxy.vratiPovezanaDokumenta(id);
    }
    vratiRezervneDeloveUSkladistu(skladiste: number) {
        return this.rezervniDeloviProxy.vratiRezervneDeloveUSkladistu(skladiste);
    }
    vratiPodesavanjeSistema() {
        return this.podesavanjeSistemaProxy.vratiPodesavanjeSistema();
    }
    sacuvajPodesavanjeSistema(podesavanjeSistema: PodesavanjeSistema) {
        return this.podesavanjeSistemaProxy.sacuvajPodesavanjeSistema(podesavanjeSistema);
    }
    sacuvajPodsetnikVozila(podsetnikVozila: PodsetnikVozila) {
        return this.podsetniciProxy.sacuvajPodsetnikVozila(podsetnikVozila);
    }
    vratiPodsetnikVozilaPoId(idPodsetnika: number) {
        return this.podsetniciProxy.vratiPodsetnikVozilaPoId(idPodsetnika);
    }
    vratiPodsetnikePoVozilu(idVozila: number) {
        return this.podsetniciProxy.vratiPodsetnikePoVozilu(idVozila);
    }
    vratiPodsetnikeVozila() {
        return this.podsetniciProxy.vratiPodsetnikeVozila();
    }
    sacuvajPodsetnikOsobe(podsetnikOsobe: PodsetnikOsobe) {
        return this.podsetniciProxy.sacuvajPodsetnikOsobe(podsetnikOsobe);
    }
    vratiPodsetnikeOsobe(idOsobe: number) {
        return this.podsetniciProxy.vratiPodsetnikeOsobe(idOsobe);
    }
    vratiPodsetnikeOsoba() {
        return this.podsetniciProxy.vratiPodsetnikeOsoba();
    }
    vratiPodsetnikOsobePoId(idPodsetnika: number) {
        return this.podsetniciProxy.vratiPodsetnikOsobePoId(idPodsetnika);
    }
    vratiOpisePodsetnikaVozila(term: string) {
        return this.podsetniciProxy.vratiOpisePodsetnikaVozila(term);
    }
    vratiOpisePodsetnikaOsoba(term: string) {
        return this.podsetniciProxy.vratiOpisePodsetnikaOsoba(term);
    }
    obrisiPodsetnik(id: number) {
        return this.podsetniciProxy.obrisiPodsetnik(id);
    }
    vratiOdsustva(godina: number) {
        return this.odsustvaProxy.vratiOdsustva(godina);
    }
    sacuvajOdsustvo(odsustvo: Odsustvo) {
        return this.odsustvaProxy.sacuvajOdsustvo(odsustvo);
    }
    vratiDnevnoRadnoVreme(godina: number, mesec: number, osoba?: number, mestoTroska?: number) {
        return this.evidencijaAktivnostiProxy.vratiDnevnoRadnoVreme(godina, mesec, osoba, mestoTroska);
    }
    vratiStampuEvidencijeRadnihVremenaVozaca(godina: number, mesec?: number, vozac?: number, mestoTroska?: number) {
        return this.evidencijaAktivnostiProxy.vratiStampuEvidencijeRadnihVremenaVozaca(godina, mesec, vozac, mestoTroska)
    }
    uveziTahografDatoteku(datoteka: FileParameter) {
        return this.evidencijaAktivnostiProxy.uveziDatoteku(datoteka);
    }
    vratiUvezeneDatoteke() {
        return this.evidencijaAktivnostiProxy.vratiUvezeneDatoteke();
    }
    obrisiOdsustvo(id: number) {
        return this.odsustvaProxy.obrisiOdsustvo(id);
    }
    vratiVrsteOdsustva() {
        return this.odsustvaProxy.vratiVrsteOdsustva();
    }
    vratiPeriode() {
        return this.evidencijaAktivnostiProxy.vratiPeriode();
    }
    vratiMesecnoRadnoVreme(period: number, osoba?: number) {
        return this.evidencijaAktivnostiProxy.vratiMesecnoRadnoVreme(period, osoba);
    }
    vratiPreostaloRadnoVreme(datum: Date, osoba?: number) {
        return this.evidencijaAktivnostiProxy.vratiPreostaloRadnoVreme(datum, osoba);
    }
    vratiPozicijeVozila() {
        return this.vozilaProxy.vratiPozicijeVozila();
    }
    vratiServisneOperacijePoNazivu(naziv: string) {
        return this.servisneOperacijeProxy.vratiServisneOperacijePoNazivu(naziv);
    }
    sacuvajPutniNalog(putniNalog: PutniNalog) {
        return this.putniNaloziProxy.sacuvajPutniNalog(putniNalog);
    }
    vratiPutniNalogPoId(id: number) {
        return this.putniNaloziProxy.vratiPutniNalogPoId(id);
    }
    vratiPutneNalogePoBroju(broj: string) {
        return this.putniNaloziProxy.vratiPutneNalogePoBroju(broj);
    }
    zakljuciPutniNalog(putniNalog: PutniNalog) {
        return this.putniNaloziProxy.zakljuciPutniNalog(putniNalog);
    }
    vratiPutneNaloge(odDatuma: Date | undefined, doDatuma: Date | undefined, vozac: number | null | undefined, brojNaloga: string | null | undefined, vozilo: number | null | undefined) {
        return this.putniNaloziProxy.vratiPutneNaloge(odDatuma, doDatuma, brojNaloga, vozac, vozilo);
    }
    vratiNalogeZaSluzbenoPutovanje(odDatuma: Date | undefined, doDatuma: Date | undefined, brojNaloga: string | null | undefined, vozac: number | null | undefined) {
        return this.putniNaloziProxy.vratiNalogeZaSluzbenoPutovanje(odDatuma, doDatuma, brojNaloga, vozac, undefined);
    }
    vratiStampuNalogaZaSluzbenoPutovanje(odDatuma: Date | undefined, doDatuma: Date | undefined, brojNaloga: string | null | undefined, vozac: number | null | undefined) {
        return this.putniNaloziProxy.vratiStampuNalogaZaSluzbenoPutovanje(odDatuma, doDatuma, brojNaloga, vozac, undefined);
    }
    vratiTroskoveOdrzavanjaPoMesecima(godina: number, grupaVozila?: number | null, kategorijaVozila?: number | null, vozilo?: number | null, mesec?: number | null) {
        return this.izvestajiOdrzavanjaVozila.vratiTroskoveOdrzavanjaPoMesecima(godina, grupaVozila, kategorijaVozila, vozilo, mesec);
    }
    vratiStampuPutnogNaloga(id: number) {
        return this.putniNaloziProxy.vratiStampuPutnogNaloga(id);
    }
    uveziSipanjeGoriva(file: FileParameter, provajder) {
        return this.sipanjeGorivaProxy.uveziSipanjeGoriva(file, provajder);
    }
    vratiUvezeneDatotekeSipanjaGoriva() {
        return this.sipanjeGorivaProxy.vratiUvezeneDatoteke();
    }
    vratiDashboard() {
        return this.dashboardProxy.vratiDashboard();
    }
    vratiUvezeneDatotekeKretanjaVozila() {
        return this.vozilaProxy.vratiUvezeneDatotekeKretanjaVozila();
    }
    uveziKretanjaVozila(file: FileParameter, provajder: number) {
        return this.vozilaProxy.uveziKretanjaVozila(file, provajder);
    }
    vratiIzvesteajEvidencijeSipanjaIPotrosnjeGoriva(odDatuma: Date, doDatuma: Date, grupaVozila?: number, vozilo?: number) {
        return this.sipanjeGorivaProxy.vratiIzvesteajEvidencijeSipanjaIPotrosnjeGoriva(odDatuma, doDatuma, grupaVozila, vozilo);
    }
    vratiTroskoveIzabranogVozila(vozilo: number) {
        return this.vozilaProxy.vratiTroskoveVozila(vozilo);
    }
    vratiZaglavljePregledaVozila(vozilo: number) {
        return this.vozilaProxy.vratiZaglavljePregledaVozila(vozilo);
    }
    vratiIzvestajPredjenihKilometaraIPotrosnjeGorivaPoGrupamaVozila(godina: number) {
        return this.izvestajiProxy.vratiIzvestajPredjenihKilometaraIPotrosnjeGorivaPoGrupamaVozila(godina);
    }
    vratiTroskovePoVozilima() {
        return this.izvestajiProxy.vratiTroskovePoVozilima();
    }
    vratiPrejdeneKilometreVozilaIVozaca() {
        return this.izvestajiProxy.vratiPrejdeneKilometreVozilaIVozaca();
    }
    vratiPregledKretanjaVozila(odDatuma: Date, doDatuma: Date, vozilo: number) {
        return this.izvestajiProxy.vratiPregledKretanjaVozila(odDatuma, doDatuma, vozilo);
    }
    vratiPregledKretanjaVozaca(odDatuma: Date, doDatuma: Date, vozac: number) {
        return this.izvestajiProxy.vratiPregledKretanjaVozaca(odDatuma, doDatuma, vozac);
    }
    sacuvajTransakcijeKorisnika(transakcijeKorisnika: TransakcijeKorisnika) {
        return this.transakcijeProxy.sacuvajTransakcijeKorisnika(transakcijeKorisnika);
    }
    vratiTransakcijeKorisika(idOsobe: number) {
        return this.transakcijeProxy.vratiTransakcijeKorisika(idOsobe);
    }
    vratiB2BPodatkeOsobe(idOsobe: number) {
        return this.osobeProxy.vratiB2BPodatkeOsobe(idOsobe);
    }
    sacuvajB2BPodatkeOsobe(osoba: number, podaci: B2BPodatakOsobe[]) {
        return this.osobeProxy.sacuvajB2BPodatkeOsobe(osoba, podaci);
    }
    vratiB2BProvajdere(tip: number | null) {
        return this.b2bProvajderiProxy.vratiB2BProvajdere(tip);
    }
    vratiEvidencijuAktivnostiVozaca(datum: Date, vozac: number | null) {
        return this.evidencijaAktivnostiProxy.vratiEvidencijuAktivnostiVozaca(datum, vozac);
    }
    vratiAktivnostiVozacaIzGps(datum: Date, vozac: number | null) {
        return this.evidencijaAktivnostiProxy.vratiAktivnostiVozacaIzGps(datum, vozac);
    }
    sacuvajEvidencijuAktivnostiVozaca(datum: Date, vozac: number | null, evidencija: EvidencijaAktivnostiVozaca[]) {
        return this.evidencijaAktivnostiProxy.sacuvajEvidencijuAktivnostiVozaca(datum, vozac, evidencija);
    }
    vratiAktivnosti() {
        return this.aktivnostiProxy.vratiAktivnosti();
    }
    sacuvajStetniDogadjaj(stetniDogadjaj: StetniDogadjaj) {
        return this.steteProxy.sacuvajStetniDogadjaj(stetniDogadjaj);
    }
    vratiStetneDogadjaje(odDatuma: Date | null, doDatuma: Date | null, brojStete: string | null, brojZapisnika: string | null, brojPolise: string | null, vozilo: number | null, vozac: number | null) {
        return this.steteProxy.vratiStetneDogadjaje(odDatuma, doDatuma, brojStete, brojZapisnika, brojPolise, vozilo, vozac);
    }
    vratiStetneDogadjajeVozila(vozilo: number) {
        return this.steteProxy.vratiStetneDogadjajeVozila(vozilo);
    }
    zakljuciStetniDogadjaj(stetniDogadjaj: StetniDogadjaj) {
        return this.steteProxy.zakljuciStetniDogadjaj(stetniDogadjaj);
    }
    vratiVoziloPoRegistraskomIliGaraznomBroju(broj: string) {
        return this.vozilaProxy.vratiVoziloPoRegistraskomIliGaraznomBroju(broj);
    }
    promeniMojuLozinku(lozinka: NovaLozinka | null) {
        return this.osobeProxy.promeniMojuLozinku(lozinka);
    }
    vratiDnevnaRadnaVremenaZaNalogZaSluzbenaPutovanja(odDatuma: Date, doDatuma: Date,
                                                      organizacionaJedinica: number | null | undefined,
                                                      vozac: number | null | undefined) {
        return this.naloziZaSluzbenaPutovanjaProxy.vratiDnevnaRadnaVremenaZaNalogZaSluzbenaPutovanja(odDatuma, doDatuma, organizacionaJedinica, vozac);
    }
    vratiStampuNalogaZaSluzbenaPutnovanja(dnevnice: DnevnoAktivnoVreme[]) {
        return this.naloziZaSluzbenaPutovanjaProxy.vratiStampuNalogaZaSluzbenaPutnovanja(dnevnice);
    }
    sacuvajStavkuSipanjaGoriva(stavka) {
        return this.sipanjeGorivaProxy.sacuvajStavkuSipanjaGoriva(stavka);
    }
    vratiAnalitikuTroskovaOdrzavanja(godina: number | null, mesec: number | null, kategorijaVozila: number | null, grupaVozila: number | null, vozilo: number | null, vrstaOdrzavanja: number | null) {
        return this.izvestajiOdrzavanjaVozila.vratiAnalitikuTroskovaOdrzavanja(godina, mesec, kategorijaVozila, grupaVozila, vozilo, vrstaOdrzavanja);
    }
    vratiObracunStimulacijeVozacima(odDatuma: Date, doDatuma: Date, organizacionaJedinica: number | null) {
        return this.obracunStimulacijeVozacimaProxy.vratiObracunStimulacijeVozacima(odDatuma, doDatuma, organizacionaJedinica);
    }
    vratiStampuObracunaStimulacijeVozacima(odDatuma: Date, doDatuma: Date, organizacionaJedinica: number | null) {
        return this.obracunStimulacijeVozacimaProxy.vratiStampuObracunaStimulacijeVozacima(odDatuma, doDatuma, organizacionaJedinica);
    }
    uveziPodatkeZaObracunStimulacije(zvtFile, vl06fFile) {
        const frm = new FormData();
        frm.append('Zvt', zvtFile);
        frm.append('VL06F', vl06fFile);
        return axios.post('/api/ObracunStimulacijeVozacima/UveziPodatke', frm);
    }

    obracunajStimulacijuVozacima(odDatuma: Date, doDatuma) {
        return this.obracunStimulacijeVozacimaProxy.obracunajStimulacijuVozacima(odDatuma, doDatuma);
    }
    zakljuciObracunStimulacijeVozacima(odDatuma: Date, doDatuma) {
        return this.obracunStimulacijeVozacimaProxy.zakljuciObracunStimulacijeVozacima(odDatuma, doDatuma);
    }

    obirisDokument(id: number) {
        return this.dokumentaProxy.obrisiDokument(id);
    }

    obrisiPodatke(vrstaBrisanja: number, godina: number, mesec: number) {
        return this.brisanjePodatakaProxy.obrisiPodatke(new ObrisiPodatkeRequest({vrstaBrisanja: vrstaBrisanja, godina: godina, mesec: mesec}));
    }

    vratiPlanTura(datum: Date) {
        return this.threePLProxy.vratiPlanTura(datum);
    }

    uveziPlanRuta(zvt12) {
        const frm = new FormData();
        frm.append('zvt12', zvt12);
        return axios.post('/api/ThreePL/UveziPodatke', frm);
    }
}

export default new DataProxyService();
